import { render, staticRenderFns } from "./NomeDocumento.vue?vue&type=template&id=6737b46e"
import script from "./NomeDocumento.vue?vue&type=script&lang=js"
export * from "./NomeDocumento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports